import emailjs from '@emailjs/browser';
import {
  faCalendarCheck,
  faChevronLeft,
  faChevronRight,
  faCubes,
  faMicroscope,
  faSmile,
  faUserMd,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import canalsSrc from '../../../assets/images/canals.png';
import cariesSrc from '../../../assets/images/caries.png';
import certificate1 from '../../../assets/images/d_certificate_1.jpg';
import certificate2 from '../../../assets/images/d_certificate_2.jpg';
import certificate3 from '../../../assets/images/d_certificate_3.jpg';
import desktopMain from '../../../assets/images/desktop_main.png';
import gigiensSrc from '../../../assets/images/gigiens.png';
import logo from '../../../assets/images/logo2.png';
import otbelivanieSrc from '../../../assets/images/otbelivanie.png';
import doctorPhoto from '../../../assets/images/photo_1.jpg';
import vinirsSrc from '../../../assets/images/vinirs.png';
import CloseIcon from '../../../components/Icons/CloseIcon';
import s from './MainDesktop.module.scss';

const servicesList = [
  { text: 'Лечение кариеса', icon: <img src={cariesSrc} />, price: '7000р.' },
  { text: 'Профессиональная гигиена полости рта', icon: <img src={gigiensSrc} />, price: '5000р.' },
  { text: 'Лечение каналов', icon: <img src={canalsSrc} />, price: 'от 6000р.' },
  { text: 'Коронки, виниры', icon: <img src={vinirsSrc} />, price: '25000р.' },
  { text: 'Отбеливание Zoom4', icon: <img src={otbelivanieSrc} />, price: '25000р.' },
];

const reviewsList = [
  {
    id: 1,
    rating: 5,
    name: 'Сергей Понасенков',
    text: `Никогда не думал, что скажу: "Хожу в стоматологию с удовольствием"! Спасибо Зареме Идрисовне за её чуткое отношение и профессионализм. Она находит подход даже к самым нервным пациентам и всегда заботится о комфорте. Абсолютно не чувствую боли во время лечения. Очень благодарен!`,
  },
  {
    id: 2,
    rating: 4.4,
    name: 'Иванова Анастасия',
    text: 'Газдиева Зарема Идрисовна удаляла мне зубной камень и налет, очень хороший специалист, эффект держится долго. Зарема Идрисовна у вас золотые руки! Если бы вы знали как хорошо она пломбы делает - не больно, быстро и качественно! Довольна всем!!!',
  },
  {
    id: 3,
    rating: 4.9,
    name: 'Милана Хамчиева',
    text: 'Когда мне нужно было сделать пломбу, я выбрала Зарему, и не ошиблась. Она объяснила все шаги, работала быстро и аккуратно. Все прошло просто отлично, а результат превзошел все ожидания. Обязательно буду обращаться только к ней',
  },
  {
    id: 4,
    rating: 5,
    name: 'Алина',
    text: 'Не могу не отметить высокий профессионализм Заремы. Я пришла к ней с болями в зубе, и она быстро нашла причину и устранила её. Очень внимательная, чуткая и, что немаловажно, умело создающая атмосферу доверия. Приятно обращаться к настоящему специалисту',
  },
  {
    id: 5,
    rating: 4.7,
    name: 'Ольга Мизинова',
    text: 'К доктору  Зареме Идрисовне попала уже после не совсем успешного лечения 3-х канального зуба в другой клинике. Провела тщательную диагностику, сумела ликвидировать последствия неудачного лечения и сохранить зуб!!! Бесконечная моя благодарность!',
  },
];

const certificatesList = [certificate1, certificate2, certificate3];

const educationList = [
  'ФГАОУ ВПО «Северо-Восточный федеральный университет имени М.К. Аммосова» г. Якутск, специальность «Стоматология» (2015 г.)',
  'ФГБОУ ВО «Северо-Западный государственный медицинский университет имени И.И. Мечникова» Министерства здравоохранения Российской Федерации. Присвоена квалификация «Стоматология общей практики» (2016 г.)',
  'ФГБОУ ВО «Северо-Западный государственный медицинский университет имени И.И. Мечникова» Министерства здравоохранения Российской Федерации, «Стоматология хирургическая» (2016 г.)',
  '2018 г. - «Адгезивные керамические реставрации в практике врача-стоматолога», Карэн Чувашьян',
  '2018 г. - Первый стоматологический конгресс по эндодонтии ProEndo, Михаил Соломонов',
];

const calculateRating = (number) => (number / 5) * 100;
const stars = Array(5).fill();

const phone = '+7 (911) 114-65-66';
const schedule = 'Пн-Вс: 10:00-20:00';

function ContactForm({ onBack }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const formRef = useRef(null);
  const textareaRef = useRef(null);

  // Авторасширение textarea
  const handleMessageChange = (e) => {
    setMessage(e.target.value);
    if (e.target.value.length > 100 && textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !phone) return;
    setLoading(true);
    setError(false);
    setSuccess(false);
    try {
      const response = await emailjs.sendForm(
        process.env.REACT_APP_EMAIL_SERVICE_ID,
        process.env.REACT_APP_EMAIL_TEMPLATE_ID,
        formRef.current,
        { publicKey: process.env.REACT_APP_EMAIL_PUBLIC_KEY }
      );
      if (response.status === 200) {
        setSuccess(true);
        setName('');
        setPhone('');
        setMessage('');
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={s.contactFormWrapper}>
      <h2>Оставьте заявку</h2>
      {success && (<div style={{ color: '#368c8a', textAlign: 'center', marginBottom: 16 }}>
        Спасибо! Ваша заявка отправлена
      </div>)}
      {error && (<div style={{ color: 'red', textAlign: 'center', marginBottom: 16 }}>
        Ошибка отправки. Попробуйте позже
      </div>)}
      <form ref={formRef} className={s.contactForm} onSubmit={handleSubmit}>
        <label>
          Имя
          <input type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} required />
        </label>
        <label>
          Телефон
          <input type="tel" name="phone" value={phone} onChange={(e) => setPhone(e.target.value)} required />
        </label>
        <label>
          Сообщение
          <textarea
            ref={textareaRef}
            name="message"
            value={message}
            onChange={handleMessageChange}
            rows={3}
            style={{ resize: 'none', minHeight: 60 }}
            placeholder="Введите сообщение..."
          />
        </label>
        <div className={s.contactFormBtns}>
          <button type="button" onClick={onBack} className={s.backBtn} disabled={loading}>
            Назад
          </button>
          <button type="submit" className={s.submitBtn} disabled={loading}>
            {loading ? 'Отправка...' : 'Отправить'}
          </button>
        </div>
      </form>
    </div>
  );
}

ContactForm.propTypes = {
  onBack: PropTypes.func.isRequired,
};

const ContentDesktop = () => {
  const [showForm, setShowForm] = useState(false);
  const [activeReview, setActiveReview] = useState(null);
  const [activeCertificate, setActiveCertificate] = useState(null);
  const reviewsScrollRef = useRef(null);
  // Удаляю импорт faBars

  // refs для секций
  const educationRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const advantagesRef = useRef(null);
  const reviewsRef = useRef(null);
  const certificatesRef = useRef(null);
  const mapRef = useRef(null);

  const navLinks = [
    { label: 'Образование', ref: educationRef },
    { label: 'О клинике', ref: aboutRef },
    { label: 'Услуги', ref: servicesRef },
    { label: 'Преимущества', ref: advantagesRef },
    { label: 'Отзывы', ref: reviewsRef },
    { label: 'Сертификаты', ref: certificatesRef },
    { label: 'Карта', ref: mapRef },
  ];

  const handleNavClick = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handleReviewClick = (review) => setActiveReview(review);
  const handleModalClose = (e) => {
    if (e.target.classList.contains(s.reviewModalOverlay) || e.target.classList.contains(s.closeIcon)) {
      setActiveReview(null);
    }
  };
  const handleCloseReview = () => {
    setActiveReview(null);
  };

  const handleCertificateClick = (img) => setActiveCertificate(img);
  const handleCertificateModalClose = (e) => {
    if (e.target.classList.contains(s.certificateModalOverlay) || e.target.classList.contains(s.closeIcon)) {
      setActiveCertificate(null);
    }
  };

  const handleCertificateClose = () => {
    setActiveCertificate(null);
  };

  // Прокрутка по стрелкам
  const scrollReviews = (direction) => {
    const el = reviewsScrollRef.current;
    if (!el) return;
    const scrollAmount = 320; // ширина одного блока + gap
    if (direction === 'left') {
      el.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  const advantagesData = [
    {
      text: 'Современные технологии и оборудование',
      icon: faMicroscope,
    },
    {
      text: 'Квалифицированные специалисты',
      icon: faUserMd,
    },
    {
      text: 'Использование качественных материалов',
      icon: faCubes,
    },
    {
      text: 'Комфорт и безболезненность',
      icon: faSmile,
    },
    {
      text: 'Гибкая система записи и удобный график работы',
      icon: faCalendarCheck,
    },
  ];

  if (showForm) {
    return <ContactForm onBack={() => setShowForm(false)} />;
  }

  return (
    <div className={s.container}>
      <header className={s.header}>
        <div className={s.headerLeft}>
          <img src={logo} className={s.headerLogo} alt="logo" />
        </div>
        <nav className={s.headerNav}>
          {navLinks.map((link) => (
            <button key={link.label} className={s.headerNavLink} onClick={() => handleNavClick(link.ref)}>
              {link.label}
            </button>
          ))}
        </nav>
        <div className={s.headerDivider} />
        <div className={s.headerRight}>
          <div className={s.headerPhone}>
            <a href="tel:89111146566">{phone}</a>
          </div>
          <div className={s.headerSchedule}>{schedule}</div>
        </div>
      </header>
      <main>
        <section className={s.heroSection}>
          <div className={s.heroOverlay}>
            <div className={s.heroClinicTitle}>Клиника доктора Заремы</div>
            <button className={s.consultBtn} onClick={() => setShowForm(true)}>
              Получить бесплатную консультацию
            </button>
          </div>
          <div className={s.heroImageWrapper}>
            <img src={desktopMain} alt="Стоматология" className={s.heroImage} />
          </div>
        </section>
        <section className={s.educationSection} ref={educationRef}>
          <div className={s.educationContent}>
            <div className={s.educationLeft}>
              <img src={doctorPhoto} className={s.heroDoctorPhoto} alt="Доктор Зарема" />
              <div className={s.heroTitle}>Газдиева Зарема Идрисовна</div>
              <div className={s.heroSubtitle}>Стоматолог-терапевт, стоматолог-ортопед</div>
            </div>
            <div className={s.educationRight}>
              <h2>Образование</h2>
              <ul className={s.heroEducationList}>
                {educationList.map((text, idx) => (
                  <li key={idx}>{text}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>
        <section className={s.aboutSection} ref={aboutRef}>
          <h2>О клинике</h2>
          <p>
            Клиника, в которой быстро, профессионально и по приемлемым ценам вас избавят от зубной боли, вернут
            возможность наслаждаться любимой едой, счастливо улыбаться и весело смеяться.
          </p>
        </section>
        <section className={s.servicesSection} ref={servicesRef}>
          <h2>Услуги</h2>
          <div className={s.servicesList}>
            {servicesList.map(({ price, text, icon }, index) => (
              <div key={index} className={s.serviceItem}>
                <div className={s.serviceIcon}>{icon}</div>
                <div className={s.serviceText}>{text}</div>
                <div className={s.servicePrice}>{price}</div>
              </div>
            ))}
          </div>
        </section>
        <section className={s.advantagesSection} ref={advantagesRef}>
          <h2>Наши преимущества</h2>
          <div className={s.advantagesListVertical}>
            {advantagesData.map(({ text, icon }, idx) => (
              <div key={idx} className={s.advantageItem}>
                <div className={s.advantageIcon}>
                  <FontAwesomeIcon icon={icon} />
                </div>
                <div className={s.advantageText}>{text}</div>
              </div>
            ))}
          </div>
        </section>
        <section className={s.reviewsSection} ref={reviewsRef}>
          <h2>Отзывы клиентов</h2>
          <div className={s.reviewsScrollWrapper}>
            <button className={s.arrowLeft} onClick={() => scrollReviews('left')} aria-label="Прокрутить влево">
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <div className={s.reviewsScroll} ref={reviewsScrollRef}>
              <div className={s.reviewsList}>
                {reviewsList.map(({ id, name, text, rating }) => (
                  <div key={id} className={s.reviewItem} onClick={() => handleReviewClick({ name, text, rating })}>
                    <div className={s.reviewHeader}>
                      <span className={s.reviewName}>{name}</span>
                      <div className={s.stars}>
                        <div className={s.starsEmpty}>
                          {stars.map((_, i) => (
                            <i key={i} className="fa-regular fa-star" />
                          ))}
                        </div>
                        <div className={s.starsFilled} style={{ width: `${calculateRating(rating)}%` }}>
                          {stars.map((_, i) => (
                            <i key={i} className="fa-solid fa-star" />
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className={s.reviewText}>{text}</div>
                  </div>
                ))}
              </div>
            </div>
            <button className={s.arrowRight} onClick={() => scrollReviews('right')} aria-label="Прокрутить вправо">
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          {activeReview && (
            <div className={s.reviewModalOverlay} onClick={handleModalClose}>
              <div className={s.reviewModal} onClick={(e) => e.stopPropagation()}>
                <div
                  className={s.closeIcon}
                  onClick={handleCloseReview}
                  style={{ right: 16, left: 'auto', top: 16, position: 'absolute' }}
                >
                  <CloseIcon size="24px" />
                </div>
                <div className={s.reviewModalName}>{activeReview.name}</div>
                <div className={s.reviewModalRating}>
                  <div className={s.stars}>
                    <div className={s.starsEmpty}>
                      {stars.map((_, i) => (
                        <i key={i} className="fa-regular fa-star" />
                      ))}
                    </div>
                    <div className={s.starsFilled} style={{ width: `${calculateRating(activeReview.rating)}%` }}>
                      {stars.map((_, i) => (
                        <i key={i} className="fa-solid fa-star" />
                      ))}
                    </div>
                  </div>
                </div>
                <div className={s.reviewModalText}>{activeReview.text}</div>
              </div>
            </div>
          )}
        </section>
        <section className={s.certificatesSection} ref={certificatesRef}>
          <h2>Сертификаты</h2>
          <div className={s.certificatesList}>
            {certificatesList.map((img, idx) => (
              <img
                key={idx}
                src={img}
                className={s.certificateImg}
                alt={`certificate-${idx + 1}`}
                onClick={() => handleCertificateClick(img)}
                style={{ cursor: 'pointer' }}
              />
            ))}
          </div>
          {activeCertificate && (
            <div className={s.certificateModalOverlay} onClick={handleCertificateModalClose}>
              <div className={s.certificateModal} onClick={(e) => e.stopPropagation()}>
                <div
                  className={s.closeIcon}
                  onClick={handleCertificateClose}
                  style={{ right: 16, left: 'auto', top: 16, position: 'absolute' }}
                >
                  <CloseIcon size="28px" />
                </div>
                <img src={activeCertificate} className={s.certificateModalImg} alt="certificate-large" />
              </div>
            </div>
          )}
        </section>
        <section className={s.mapSection} ref={mapRef}>
          <h2>Где мы находимся</h2>
          <iframe
            src="https://yandex.ru/map-widget/v1/?um=constructor%3A1d451f3edab5e61c65469690322b32df7e3ab2903935dee612570c3c66d7ebeb&amp;source=constructor"
            width="600"
            height="400"
            frameBorder="0"
            title="Карта"
          />
        </section>
      </main>
    </div>
  );
};

export default ContentDesktop;
